export default "__VITE_ASSET__xObenCLl__"